export const Module = 'Authentication';
